import React from 'react';
import styled from 'styled-components';
import ServersList from './ServersList';
import { BoxedResponsiveStyled } from "../../../../style/components/common.styled";
import AlarmsWrapperWidget from './serverWidgets/AlarmsWrapperWidget';
import AlarmsCountWrapperWidget from './serverWidgets/AlarmsCountWidget';
import UsageWidget from './serverWidgets/UsageWidget';
import { EuiIcon } from '@elastic/eui';

const ServersDashboardStyled = styled.section`
  display: grid;
  gap: 14px;
  padding: 8px;
`;

const SecondaryWidgetsStyled = styled.section`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;

  ${ BoxedResponsiveStyled } {
    margin: 0;
    min-height: 160px;
    border: 1px solid rgba(72, 77, 91, 0.75);
    box-shadow: none;
  }

  .alarm-history {
    grid-column: span 2;
  }

  @media (max-width: 960px) {
    grid-template-columns: 1fr;

    .alarm-history {
      grid-column: auto;
    }
  }
`;

const ServersDashboard = () => {
    return (
        <ServersDashboardStyled>
            <AlarmsCountWrapperWidget/>
            <ServersList/>
            <SecondaryWidgetsStyled>
                <BoxedResponsiveStyled>
                    <h3><EuiIcon type="apmTrace" size="m" /> Usage</h3>
                    <UsageWidget/>
                </BoxedResponsiveStyled>
                <BoxedResponsiveStyled className="alarm-history">
                    <AlarmsWrapperWidget/>
                </BoxedResponsiveStyled>
            </SecondaryWidgetsStyled>
        </ServersDashboardStyled>
    );
};

export default ServersDashboard;
